import React from 'react';
import { number, string, oneOfType, oneOf } from 'prop-types';
import cx from 'classnames';

import { getResponsivePropType, genResponsiveClasses } from './../../utils/';

const propTypes = {
  /** Html element. */
  tag: string,
  /** Column size. Number, 'shrink/fill/auto', or responsive map */
  size: getResponsivePropType(
    oneOfType([number, oneOf(['shrink', 'fill', 'auto', 'fixed'])])
  ),
  /** Column offset. Number, 'shrink/fill/auto/center', or responsive map */
  offset: getResponsivePropType(
    oneOfType([number, oneOf(['shrink', 'fill', 'auto', 'center'])])
  ),
  order: getResponsivePropType(number),
};

const CLASS_ROOT = 'grid__col';

const GridCol = ({ className, tag = 'div', size, offset, order, ...other }) => {
  const classes = cx(
    !size && CLASS_ROOT,
    ...genResponsiveClasses(CLASS_ROOT, size),
    ...genResponsiveClasses(CLASS_ROOT, offset, 'offset'),
    ...genResponsiveClasses(CLASS_ROOT, order, 'order'),
    className
  );

  const TagName = tag;

  return <TagName className={classes} {...other} />;
};

GridCol.displayName = 'GridCol';
GridCol.propTypes = propTypes;

export default GridCol;



// WEBPACK FOOTER //
// ./src/components/Grid/GridCol.js